import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
/**
 Top level HOC and utility for composing styles along with composing.
 * */

const propTypes = {
  className: PropTypes.string
};

const withStyles = (Component, styles, property) => {
  const WrappedComponent = ({className = '', ...rest}) => (
    <Component {...rest} className={cx(className, styles[property])} />
  );

  WrappedComponent.propTypes = propTypes;

  return WrappedComponent;
};

const withStylesCompose = (Component, styles, properties = []) => {
  const combined = cx([...properties.map(p => styles[p])]);
  return ({className = '', ...rest}) => <Component {...rest} className={cx(combined, className)} />;
};

export {withStyles, withStylesCompose};
